export enum PlayerRole {
  Driver = 'driver',
  Passenger = 'passenger',
}

export enum GamePhase {
  WaitingForPlayers = 'waiting',
  Briefing = 'briefing',
  Countdown = 'countdown',
  Playing = 'playing',
  BossEncounter = 'boss',
  Capture = 'capture',
  Escape = 'escape',
  TimeExpired = 'time_expired',
  Debrief = 'debrief',
  LevelComplete = 'level_complete',
  CampaignComplete = 'campaign_complete',
  GameOver = 'game_over',
}

export enum LevelTheme {
  Countryside = 'countryside',
  City = 'city',
  Tunnel = 'tunnel',
  Desert = 'desert',
  Swamp = 'swamp',
}

export enum EnemyType {
  Sedan = 'sedan',
  Truck = 'truck',
  Motorcycle = 'motorcycle',
  Drone = 'drone',
  Helicopter = 'helicopter',
  Boss = 'boss',
  ArmoredTarget = 'armored_target',
}

export enum DifficultyId {
  Rookie = 'rookie',
  Agent = 'agent',
  Veteran = 'veteran',
}

export enum StageOutcome {
  Captured = 'captured',
  Escaped = 'escaped',
  Destroyed = 'destroyed',
  TimeExpired = 'time_expired',
  VehicleDestroyed = 'vehicle_destroyed',
}

export enum TargetState {
  Unknown = 'unknown',
  Contact = 'contact',
  Pursuit = 'pursuit',
  Separated = 'separated',
  Reacquired = 'reacquired',
  Exposed = 'exposed',
  Disabled = 'disabled',
  Captured = 'captured',
  Escaped = 'escaped',
  Destroyed = 'destroyed',
}

export enum TargetConfiguration {
  Armored = 'armored',
  Defensive = 'defensive',
  Exposed = 'exposed',
  Critical = 'critical',
}

export enum HazardType {
  CargoDrop = 'cargo_drop',
  LaneStrike = 'lane_strike',
  TrafficCrossing = 'traffic_crossing',
  TunnelFire = 'tunnel_fire',
  Rockfall = 'rockfall',
  DustBurst = 'dust_burst',
  SwampEruption = 'swamp_eruption',
}

export enum HazardPhase {
  Warning = 'warning',
  Committed = 'committed',
  Active = 'active',
  Recovery = 'recovery',
  Complete = 'complete',
}

export enum ObstacleType {
  Barrel = 'barrel',
  Barrier = 'barrier',
  Rock = 'rock',
  Wreck = 'wreck',
  RepairKit = 'repair_kit',
}

export enum WeaponType {
  Pistol = 'pistol',
  SMG = 'smg',
  Shotgun = 'shotgun',
  Rocket = 'rocket',
}

export interface Vec3 {
  x: number;
  y: number;
  z: number;
}

export interface DriverInput {
  lateral: number;   // -1 (left) to 1 (right)
  boost: boolean;
  brake: boolean;
  aimDir: Vec3;
  shoot: boolean;
}

export interface PassengerInput {
  aimDirL: Vec3;
  shootL: boolean;
  aimDirR: Vec3;
  shootR: boolean;
  reload: boolean;
  special: boolean;
}
